module.exports = __webpack_public_path__ + "img/mobile_app-sm.6901901d.png";